export const STRUCTURED_PRODUCTS_PRODUCT_TYPES = {
    LINKED_CDS: 'Market Linked CD\'s',
    STRUCTURED_NOTES: 'Structured Notes',
};
